import { render } from "./BusinessTravelers.vue?vue&type=template&id=6177d189&scoped=true"
import script from "./BusinessTravelers.vue?vue&type=script&lang=js"
export * from "./BusinessTravelers.vue?vue&type=script&lang=js"

import "./BusinessTravelers.vue?vue&type=style&index=0&id=6177d189&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6177d189"]])

export default __exports__